import Vue from 'vue';

import store from '@/vuex/store';

import Router from 'vue-router';
import routers from './modules/index.js'

// 工具
import util from '@/utils/util.js'

// 启用路由
Vue.use(Router);

// 导出路由 
const router = new Router({
	routes: routers
})

// 路由拦截器

router.beforeEach(async (to, from, next) => {
	// vwex记录当前路由
	store.commit('changePathUrl', to.path)

	// 判断是否需要登录才可以进入 
	if (to.matched.some(_ => _.meta.requireAuth)) {
		// 获取用户信息
		const user_info = JSON.parse(util.getStore('user_info', true))
		// 获取用户 token 
		const token = util.getStore('logintoken', true)
		// 判断是否登录
		if (token && token !== 'undefined') {
			// 已登录，判断用户权限  
			if (user_info.auth == to.meta.auth) {
				// 有权限
				next()
			} else {
				// 无权限
				next({
					name: '403'
				})
			}
		} else {
			// 跳转到登录界面 携带返回页面
			next({
				name: 'login',
				query: {
					redirect: to.fullPath
				}
			})
			// 清空登录信息
			util.removeStore('token', true)
			util.removeStore('user_info', true)
		}
	} else {
		// 不需要身份校验 直接通过
		next()
	}

})



router.afterEach(to => {
	// 返回页面顶端

	window.scrollTo(0, 0)
})

export default router
